import { ColorPicker, Form, Input, InputNumber, Modal, notification, Space,Spin } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import {
    reset,
    statusLeadsEditReduxClose,
    statusLeadsEditSave,
} from "./redux/slice";
const EditStatusLeads = ({ onClose }) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const [form] = Form.useForm();
    const { loading, isOpen, data, result, error } = useSelector(
        (state) => state.statusLeadsEditRedux
    );

    const { data: allStatus } = useSelector((state) => state.statusAnnouncementListRedux);

    const lastPosition = allStatus?.count

    const [colorId, setColorId] = useState();

    //Verificacion de carga
    useEffect(() => {
        if (data) {
            form.setFieldsValue({
                ...data,
                color: data?.color || "#ffffff",
                position: data?.position,
            });
        }
    }, [data, allStatus]);

    useEffect(() => {
        if (isOpen && !data) {
            form.setFieldsValue({position: lastPosition + 1, color: "#ffffff"});
        }
    }, [isOpen, data, allStatus]);

    useEffect(() => {
        if (result) {
            dispatch(reset({ result: null }));
            notification.success({ message: messages["saveSuccessfully"] }); //, description: messages["saveSuccessfully"] })
            closeModal(true);
        }

        if (error) {
            dispatch(reset({ error: null }));
            notification.error({
                message: messages["saveError"],
                description: messages[error] || error,
            });
        }
    }, [ result, error])
    

    //se valida y se limpia todo lo que pueda causar errores
    const closeModal = useCallback((refresh) => {
        form.resetFields();
        dispatch(statusLeadsEditReduxClose());
        dispatch(reset({ result: null, data : null, error: null }));
        onClose && onClose(refresh);
    });

    return (
        <Modal
            open={isOpen}
            width={800}
            onCancel={() => closeModal()}
            footer={null}
            maskClosable={false}
        >
            <div className="p-3 p-md-5">
                <div className="text-center mb-4">
                    <h3>
                        {data?.id
                            ? messages["configStatusLeadsEdit_update"]
                            : messages["configStatusLeadsEdit_create"]}
                    </h3>
                </div>
            </div>
            <Spin spinning={loading}>
                <div className="card-body">
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={(values) => {
                            dispatch(
                                statusLeadsEditSave({
                                    id: data?.id,
                                    ...values,
                                    color: colorId,
                                })
                            );
                        }}
                    >
                        <div className="row g-3">
                            <div className="col-12">
                                <div className="row">
                                    <div className='col-6 col-md-6 p-2'>
                                        <Form.Item
                                            name="color"
                                            label={
                                                <label className="form-label">
                                                    {messages["workflow_card_color"]}
                                                </label>
                                            }
                                        >
                                            <ColorPicker
                                                defaultValue={"#ffffff"}
                                                defaultFormat="hex"
                                                format="hex"
                                                onChange={(color) => {
                                                    const hexColor = color?.toHexString();
                                                    return setColorId(hexColor);
                                                }}
                                                showText
                                            />
                                        </Form.Item>
                                    </div>
                                    {allStatus && allStatus?.count && <div className='col-6 col-md-6 p-2'>
                                        <Form.Item
                                            name="position"
                                            label={
                                                <label className="form-label">
                                                    Disposizione n° ({lastPosition} stati attiaviti)
                                                </label>
                                            }
                                        >
                                            <InputNumber min={1} max={data ? lastPosition : lastPosition + 1} />
                                        </Form.Item>
                                    </div>}
                                </div>
                                <div className="row">
                                    <div className="col-12 m-2">
                                        <Form.Item
                                            name="name"
                                            label={
                                                <label className="form-label">
                                                    {
                                                        messages[
                                                            "configStatusLeadsEdit_name"
                                                        ]
                                                    }
                                                </label>
                                            }
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        messages[
                                                            "required_field"
                                                        ],
                                                },
                                            ]}
                                        >
                                            <Input className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" />
                                        </Form.Item>
                                    </div>
                                    <div className="col-12 m-2">
                                        <Form.Item
                                            name="description"
                                            label={
                                                <label className="form-label">
                                                    {
                                                        messages[
                                                            "configStatusLeadsEdit_description"
                                                        ]
                                                    }
                                                </label>
                                            }
                                            /* rules={[
                                          {
                                            required: true,
                                            message: messages["required_field"],
                                          },
                                        ]} */
                                        >
                                            <Input className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" />
                                        </Form.Item>
                                    </div>
                                    <div className="col-12 m-2">
                                        <Form.List
                                            name="substatus"
                                            label={
                                                <label className="form-label">
                                                    Stati secondari
                                                </label>
                                            }
                                        >
                                            {(fields, { add, remove }) => (
                                                <>
                                                    {fields.map(
                                                        ({
                                                            key,
                                                            name,
                                                            ...restField
                                                        }) => (
                                                            <Space
                                                                key={key}
                                                                style={{
                                                                    display:
                                                                        "flex",
                                                                    marginBottom: 8,
                                                                }}
                                                                align="baseline"
                                                            >
                                                                <Form.Item
                                                                    {...restField}
                                                                    name={[
                                                                        name,
                                                                        "name",
                                                                    ]}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message:
                                                                                messages[
                                                                                    "required_field"
                                                                                ],
                                                                        },
                                                                    ]}
                                                                >
                                                                    <Input  placeholder={messages[
                                                                                    "configStatusLeadsEdit_name"
                                                                                ]}/>
                                                                </Form.Item>
                                                                <Form.Item
                                                                    {...restField}
                                                                    name={[
                                                                        name,
                                                                        "description",
                                                                    ]}
                                                                >
                                                                    <Input placeholder={messages[
                                                                                    "configStatusLeadsEdit_description"
                                                                                ]} />
                                                                </Form.Item>
                                                                <button
                                                                    className="btn btn-label-secondary"
                                                                    onClick={() =>
                                                                        remove(
                                                                            name
                                                                        )
                                                                    }>
                                                                    {messages['delete']}
                                                                </button>
                                                            </Space>
                                                        )
                                                    )}
                                                    <Form.Item>
                                                        <button
                                                            className="btn btn-label-primary"
                                                            onClick={() =>
                                                                add()
                                                            }>
                                                            {messages['add']} stati secondari
                                                        </button>
                                                    </Form.Item>
                                                </>
                                            )}
                                        </Form.List>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </Spin>
            <div className="row pt-5">
                <div className="col-12 text-center">
                    <button
                        type="button"
                        className="btn btn-primary me-sm-3 me-1"
                        onClick={() => form.submit()}
                    >
                        {messages["save"]}
                    </button>
                    <button
                        type="button"
                        className="btn btn-label-secondary"
                        onClick={() => closeModal()}
                    >
                        {messages["cancel"]}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default EditStatusLeads